module.exports = __webpack_public_path__ + "img/maintop.ecaaab7.png";